export default __webpack_public_path__ + "static/media/marca_negativa_open_finance.68990267.svg";